import React from 'react'
import styled from 'styled-components'
import Carousel from 'react-elastic-carousel'
import { assignPrefix } from '../../../constants'

const techImages: any = {
  js: '/blog/posts/tech/js.svg',
  react: '/blog/posts/tech/react.svg',
  nextjs: '/blog/posts/tech/nextjs.svg',
  mongodb: '/blog/posts/tech/mongodb.svg',
  postgresql: '/blog/posts/tech/postgresql.svg',
  nestjs: '/blog/posts/tech/nestjs.svg',
  aws: '/blog/posts/tech/aws.svg',
  aws_lambda: '/blog/posts/tech/aws-lambda.svg',
  aws_rds: '/blog/posts/tech/aws-rds.svg',
  apollo_graphql_long: '/blog/posts/tech/apollo-graphql-long.svg',
  apollo_graphql_compact: '/blog/posts/tech/apollo-graphql-compact.svg',
  contentful_circular: '/blog/posts/tech/contentful-circular.svg',
  contentful_wordmark: '/blog/posts/tech/contentful-wordmark.svg',
  jest: '/blog/posts/tech/jestjs.svg',
  graphql: '/blog/posts/tech/graphql.svg',
}

const Wrapper = styled.div`
  flex: 1;
  box-shadow: 0px 22px 58px rgba(0, 0, 0, 0.11);
  border-radius: 8px;
  display: flex;
  padding: 32px;
  flex: 0 1 1;
  .details {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    h3 {
      font-size: 1.5em;
      margin: 8px 0;
      color: ${p => p.theme.colors.gray[900]};
    }
    p {
      color: ${p => p.theme.colors.gray[700]};
      font-size: 20px;
      font-style: italic;
      line-height: 30px;
      margin: 16px 0;
      font-weight: 500;
    }

    span {
      color: ${p => p.theme.colors.gray[700]};
      line-height: 24px;
    }

    .tech-stack {
      margin-top: 40px;
      img {
        margin-right: 1rem;
      }
    }
  }
  @media (max-width: 900px) {
    .details {
      h3 {
        font-size: 20px;
      }
      p {
        font-size: 1rem;
        line-height: 24px;
      }
    }
  }
`

export const UsingCompanyListStacked = styled.div`
  display: inline-flex;
  flex-wrap: wrap;
  gap: 32px;
  margin-left: -64px;
  margin-right: -64px;
  @media (max-width: 900px) {
    flex-direction: column;
    margin: 0 1rem;
  }
`

export const UsingCompanyListCarousel = styled(Carousel)`
  display: inline-flex;
  overflow-x: visible;
  .rec-swipable {
    max-width: 100vw;
  }

  .rec-arrow {
    z-index: 100;
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #FFFFFF;
    box-shadow: 0px 20px 25px -5px rgba(0, 0, 0, 0.1), 0px 10px 10px -5px rgba(0, 0, 0, 0.04);
    border-radius: 9999px;
    color: ${p => p.theme.colors.gray[800]};
    &:disabled {
      color: #A0AEC0;
    }
    &-right {
      right: 10px;
      padding-left: 2px;
    }
    &-left {
      padding-right: 2px;
      left: 10px;
    }

    &:hover {
      color: black;
      box-shadow: 0px 20px 25px -5px rgba(0, 0, 0, 0.1), 0px 10px 10px -5px rgba(0, 0, 0, 0.04);
      background: white;
      &:disabled {
        color: #A0AEC0;
      }
    }
  }

  .rec-carousel {
    width: 100vw;
    position: relative;
    &:after {
      content: "";
      left: 0;
      bottom: 0;
      width: 100%;
      position: absolute;
      height: 20px;
      background: white;
      z-index: 20;
    }
  }
  .rec-slider-container {
    overflow-x: auto;
    margin: 0;
  }

  .rec-pagination {
    display: none;
  }

  .rec-carousel-item {
    box-shadow: rgb(0 0 0 / 11%) 0px 10px 20px;
    border-radius: 8px;
    margin-right: 32px;
    margin-top: 40px;
  }
  @media (max-width: 900px) {
    margin-right: 0;
    .rec-arrow {
      display: none;
    }
    .rec-carousel {
      width: 100%;
      &:after {
        content: unset;
      }
    }
    .rec-slider {
      position: relative;
      left: 0 !important;
      right: 0 !important;
      margin: 0 20px;
    }
    .rec-swipable {
      flex-direction: column !important;
      margin: 1rem 0;
      width: 100%;
    }
    .rec-carousel-item {
      margin: 1rem 0;
    }
    .rec-slider-container {
      overflow: hidden;
    }
    .rec-item-wrapper {
      width: 100% !important;
    }
  }

  @media (min-width: 900px) {
    .rec-swipable {
      margin-bottom: 80px;
    }
  }
`
const ImgWrapper = styled.div`
  width: 48px;
  height: 48px;
  overflow: hidden;
  margin-right: ${p => p.theme.space[16]};
  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`

interface UsingCompanyProps {
  title: string
  text: string
  repDetails?: string
  techStack?: string[]
  imagePath: string
  url?: string
  repUrl?: string
}

const UsingCompany: React.FC<UsingCompanyProps> = props => {
  return (
    <Wrapper>
      <ImgWrapper>
        <img src={assignPrefix(props.imagePath)} alt={props.title} />
      </ImgWrapper>
      <div className="details">
        <div>
          {props.url ? (
            <a target="_blank" href={props.url}>
              <h3>{props.title}</h3>
            </a>
          ) : (
            <h3>{props.title}</h3>
          )}
          <p>{props.text}</p>
          {props.repUrl ? (
            <a target="_blank" href={props.repUrl}>
              <span>{props.repDetails}</span>
            </a>
          ) : (
            <span>{props.repDetails}</span>
          )}
        </div>
        {props.techStack && props.techStack.length > 0 && (
          <div className="tech-stack">
            {props.techStack.map(tech => (
              <img src={assignPrefix(techImages[tech])} alt={tech} height={30} />
            ))}
          </div>
        )}
      </div>
    </Wrapper>
  )
}

export default UsingCompany
